import { ResponseMessages } from '@/services/api/types';

export type ApiErrorLike = {
  status?: number;
  body?: string;
};

export function normalizeApiErrorBody(body?: string): string | undefined {
  return body?.trim().replace(/^"|"$/g, '');
}

export function getApiErrorCode(error: ApiErrorLike): string | undefined {
  const normalizedBody = normalizeApiErrorBody(error.body);

  if (!normalizedBody) {
    return undefined;
  }

  try {
    const parsed = JSON.parse(normalizedBody) as { code?: string };
    return parsed.code?.trim();
  } catch {
    return normalizedBody;
  }
}

export function isNotFoundError(error: ApiErrorLike): boolean {
  return error.status === 404 || getApiErrorCode(error) === ResponseMessages.NotFoundCode;
}
